<div class="task-container">
  <div class="page-header">
    <span class="page-title">Contatos</span>
  </div>
  <span class="h2" style="font-weight: bold">Filtros</span>
  <div class="filters">
    <mat-form-field subscriptSizing="dynamic" [matTooltip]="'Pesquise por nome, email, telefone, bairro ou cidade'">
      <mat-label>Pesquisar</mat-label>
      <input id="contact-search" matInput (keyup)="search($event)" [value]="searchValue" placeholder="Ex. Mia" #input>
    </mat-form-field>
    <app-person-picker [selectedPeople]="selectedPeople" [people]="usersToShowBadges" (onSelectionChange)="personSelected($event)"></app-person-picker>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Tipo</mat-label>
      <mat-select [value]="selectedType || '__all__'" (selectionChange)="typeSelected($event)">
        <mat-option value="__all__">Todos</mat-option>
        <mat-option value="PF">Pessoa Física</mat-option>
        <mat-option value="PJ">Pessoa Jurídica</mat-option>
      </mat-select>
    </mat-form-field>
    <app-button-w-loader
      type="yellow"
      label="+ Novo contato"
      (buttonClick)="newContact()"
      [disabled]="(contactService.contactPagination()?.total ?? 0) >= contactLimit || contactService.loading()"
      [matTooltip]="(contactService.contactPagination()?.total ?? 0) >= contactLimit ? 'Limite de Contatos atingido - Entre em contato com a Nuvex se precisar de armazenamento adicional' : ''"
      />
  </div>

  <div class="item-counter-list">
    @for (status of statusMap.keys(); track status) {
      <app-item-counter
        [title]="statusMap.get(status)?.name ?? ''"
        [value]="statusMap.get(status)?.count ?? 0"
        [titleColor]="statusMap.get(status)?.color ?? ''"
        [cardColor]="null"
        [textColor]="(statusMap.get(status)?.invertTitleColor ?? false) ? 'white' : 'black'"
      ></app-item-counter>
      @if (statusMap.get(status)?.showSeparator) {
        <div class="counter-separator"></div>
      }
    }
  </div>

  <app-contact-table
    [values]="contactService.contactList()"
    [totalItems]="contactService.contactPagination()?.total ?? 0"
    [pageSize]="pageSize()"
    (pageChange)="onPageChange($event)"
    (openDetails)="openDetails($event)">
  </app-contact-table>
</div>
